"use client"

import { useEventListener, useMemoizedFn } from "ahooks"

/**
 * 页面滚动时自动关闭下拉框/弹出层的 Hook
 * 当 open 为 true 时，监听页面滚动事件，滚动时自动调用 onClose 关闭
 * @param {boolean} open - 下拉框/弹出层的打开状态
 * @param {() => void} onClose - 关闭回调函数
 * @param {boolean} enabled - 是否启用滚动关闭功能，默认为 true
 */
export const useCloseOnScroll = (open: boolean, onClose: () => void, enabled: boolean = true): void => {
  const handleClose = useMemoizedFn(() => {
    onClose()
  })

  useEventListener("scroll", handleClose, {
    capture: true,
    enable: enabled && open,
    passive: true,
  })

  useEventListener("click", handleClose, {
    enable: enabled && open,
    target: () => document,
  })
}
